import React, { useRef } from 'react';
import Flex from 'components/Flex';
import styled from 'styled-components';
import Footer from './Footer';
import useLeftMenu from './useLeftMenu';
import useWebsiteMenu from './useWebsiteMenu';
import WebsiteMenuItem, { WebsiteWrapper } from './WebsiteMenuItem';
import SidebarNotice from 'components/Notices/Sidebar';
import { useStickyOffset } from 'hooks/useStickyOffset';

const MENU_WIDTH = 256;
const FOOTER_HEIGHT = 176;

const LeftMenuDesktop = ({ sticky = true }) => {
  const { renderItems } = useLeftMenu();
  const { isVisible: isWebsiteMenuVisible } = useWebsiteMenu();

  const itemsRef = useRef<HTMLDivElement>(null);
  const { topOffset } = useStickyOffset(itemsRef, { sticky });

  return (
    <Menu direction="column" justifyContent="space-between">
      <ItemsWrapper sticky={sticky} topOffset={topOffset}>
        <ItemsContainer ref={itemsRef}>
          {renderItems()}
          {isWebsiteMenuVisible && (
            <WebsiteWrapper>
              <WebsiteMenuItem />
            </WebsiteWrapper>
          )}
          <SidebarNotice hasTopBorder={isWebsiteMenuVisible} />
        </ItemsContainer>
        <FooterSpacer />
      </ItemsWrapper>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Menu>
  );
};

export default LeftMenuDesktop;

const Menu = styled(Flex)`
  width: ${MENU_WIDTH}px;
  background-color: ${(props) => props.theme.colors.dark};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  ${(props) => props.theme.media.md`
    display: none;
  `}
  @media print {
    display: none;
  }
`;

const ItemsWrapper = styled.div<{ sticky: boolean; topOffset: number }>`
  position: ${(p) => (p.sticky ? 'sticky' : 'relative')};
  top: ${(p) => (p.sticky ? `${p.topOffset}px` : '0')};
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${MENU_WIDTH}px;
  z-index: 0;
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const FooterSpacer = styled.div`
  height: ${FOOTER_HEIGHT}px;
  flex-shrink: 0;
`;

const FooterWrapper = styled.div`
  position: relative;
  z-index: 1;
`;
